/* eslint-disable import/prefer-default-export */

const _defaultParams = {
  scope: document,
  excludeHostnames: [],
  excludeContentClasses: '.fa,.fas,.fa-solid,.far,.fa-regular,.fab,.fa-brands',
  iconHtml: ` 
    <i class="fas fa-external-link-alt" title="Off-site link" aria-hidden="true"></i>
    <span class="visually-hidden">(off-site)</span>
  `,
};

function hostnameMatch(hostname, matchList) {
  // hostname is not a property on <a> elements inside an <svg>.
  if (!hostname) {
    return false;
  }

  const matches = matchList.filter((item) => {
    if (item.slice(0, 2) === '*.') {
      return hostname.endsWith(item.slice(2));
    }

    return hostname === item;
  });

  return !!matches.length;
}

export function addExternalLinkIcons(params) {
  params = { ..._defaultParams, ...params };

  params.scope
    .querySelectorAll('a[href^=http]:not(.no-ext-icon)')
    .forEach((element) => {
      if (
        hostnameMatch(element.hostname, params.excludeHostnames) ||
        element.querySelector(params.excludeContentClasses) !== null
      ) {
        return;
      }

      element.innerHTML += params.iconHtml;
    });
}
